module.exports = __webpack_public_path__ + "media/images/img/seikousya/isid-57e09b808a6da47a5be3e1649ca844bc.png";